import React, { createContext, useState, useMemo } from 'react';

export const StatsContext = createContext();

export const StatsProvider = ({ children }) => {
    const [currStat,setCurrStat]=useState(null);

  const value = useMemo(() => ({ currStat, setCurrStat }), [currStat]);

  return (
    <StatsContext.Provider value={value}>
      {children}
    </StatsContext.Provider>
  );
};
